// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Filtro_PegafiltrosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * @phpstan-type FiltroFranquia object{FranquiaID: int|string, FuncionariosIDs?: list<string>}
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Filtro_PegafiltrosResponseDados {
Franquias: object
DataInicio: string
DataFim: string
}

export type Filtro_PegafiltrosResponse = ApiResponse<Filtro_PegafiltrosResponseDados>;

registerResponseContract('Filtro_PegafiltrosResponse', {
  Franquias:  { type: 'object',  required: true },
  DataInicio: { type: 'string',  required: true },
  DataFim:    { type: 'string',  required: true },
})
